import { captureException, captureMessage } from '@sentry/react';

export const notifySentry = (
  messageOrError: string | Error,
  details?: object
) => {
  if (typeof messageOrError === 'string') {
    console.warn(messageOrError, details);
    captureMessage(messageOrError, details);
  } else {
    console.error(messageOrError, details);
    captureException(messageOrError, details);
  }
};
